<template>
    <div>
        <Sphere :items="menuItemCount" :color="color">
            <template v-slot:center>
            </template>
            <template v-slot:buttons>
                <SphereButton
                    :label="$t('appointment_list.planning')"
                    :selected="selected == 'planning'"
                    :color="color"
                    @click="showAppointmentList"
                >
                    <img src="/img/icon-planning-white.svg" v-if="selected == 'planning'">
                    <img src="/img/icon-planning.svg" v-else>
                </SphereButton>

                <SphereButton
                    :label="$t('appointment_list.new_user')"
                    :selected="selected == 'appointment-menu'"
                    :color="color"
                    lineClass="top-small"
                    @click="showNewClient()"
                >
                    <img src="/img/icon-new-user-white.svg" v-if="selected == 'appointment-menu'">
                    <img src="/img/icon-new-user.svg" v-else>
                </SphereButton>

                <SphereButton
                    :label="$t('appointment_list.existing_user')"
                    :selected="selected == 'client-search'"
                    :color="color"
                    :lineClass="menuItemCount == 4 ? 'bottom-small' : ''"
                    @click="showViewClient()"
                >
                    <img src="/img/icon-existing-white.svg" v-if="selected == 'client-search'">
                    <img src="/img/icon-existing.svg" v-else>
                </SphereButton>

                <SphereButton
                    :label="$t('appointment_list.measurements')"
                    :selected="selected == 'appointment-list-completed'"
                    :color="color"
                    :lineClass="menuItemCount == 5 ? 'bottom-small' : ''"
                    @click="showCompletedAppointments()"
                >
                    <img src="/img/icon-completed-list-white.svg" v-if="selected == 'appointment-list-completed'">
                    <img src="/img/icon-completed-list.svg" v-else>
                </SphereButton>

                <SphereButton
                    v-if="hasDemoBeds"
                    :label="$t('demo_beds.title')"
                    :selected="selected == 'demo-beds'"
                    :color="color"
                    @click="showDemoBed()"
                >
                    <img src="/img/icon-demo-beds-white.svg" v-if="selected == 'demo-beds'">
                    <img src="/img/icon-demo-beds.svg" v-else>
                </SphereButton>
            </template>
        </Sphere>
    </div>
</template>

<script>
import Sphere from "@/components/app/Sphere.vue";
import SphereButton from "@/components/app/SphereButton.vue";
import {apiStore} from "@/stores/api.js";

export default {
    name: "SphereNavigation",
    components : {Sphere, SphereButton},
    props: {
        color: {
            type: String,
            default: "green"
        },
        selected: {
            type : String,
            default : "planning"
        }
    },

    computed: {
        hasDemoBeds() {
            return apiStore().shop && apiStore().shop.has_demo_beds;
        },

        menuItemCount() {
            return this.hasDemoBeds ? 5 : 4;
        }
    },

    methods: {
        showAppointmentList() {
            this.gotoRoute("appointment-list");
        },

        showNewClient() {
            this.gotoRoute("appointment-menu");
        },

        showViewClient() {
            this.gotoRoute("client-search");
        },

        showCompletedAppointments() {
            this.gotoRoute("appointment-list-completed");
        },

        showDemoBed() {
            this.gotoRoute("demo-beds");
        },

        gotoRoute(name) {
            if (this.$route.name !== name) {
                this.$router.push({name});
            }
        }
    }
};
</script>
